const fonts = require('./fonts.json');
function loadFont(id, doc = document) {
  const font = fonts.find(f => f.id === id) || fonts[0];
  let link = doc.getElementById('brb-selected-font');
  if(font.remote) {
    if(!link) {link = doc.createElement('link');link.id = 'brb-selected-font';link.rel = 'stylesheet';doc.head.appendChild(link);}
    const href = 'https://fonts.googleapis.com/css2?family=' + encodeURIComponent(font.name) + ':wght@400;700&display=swap';
    if(link.getAttribute('href') !== href) link.setAttribute('href',href);
  } else if(link) link.remove();
  return '"' + font.name + '", ' + font.fallback;
}
module.exports = {loadFont};
